import React, { useState } from 'react';
import { Button } from '../../../../common/components';
import { mergeAndArchiveDocuments } from '../../redux/policyActions';
import { connect } from 'react-redux';

//import './styles.scss';
import DownloadDocumentsForm from './DownloadDocumentsForm';
import { Modal } from 'react-bootstrap';

const DownloadDocumentsButton = ({
  resourceId,
  resourceType,
  onDownloadDocuments,
  documents,
  label,
  isLoading,
  disabled,
}) => {
  const [show, setShow] = useState(false);

  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <Button
        className="pull-right"
        bsStyle="primary"
        label={label || 'Download Documents'}
        rightIcon="file"
        isLoading={isLoading}
        disabled={disabled}
        handleClick={handleOpen}
      />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Download Documents</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {show && (
            <DownloadDocumentsForm
              documents={documents}
              onDownloadDocuments={onDownloadDocuments}
              onCloseModal={handleClose}
              resourceType={resourceType}
              resourceId={resourceId}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default connect(
  null,
  {
    onDownloadDocuments: mergeAndArchiveDocuments,
  },
)(DownloadDocumentsButton);
